import { render, staticRenderFns } from "./itcIndex.vue?vue&type=template&id=36bc0111"
import script from "./itcIndex.vue?vue&type=script&lang=js"
export * from "./itcIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports